export default __webpack_public_path__ + "static/media/chip_tray_page.810e5868.png";